export const DOM_CANCELATION_INSURANCE = 'DOM_CANCELATION_INSURANCE'
export const INTL_CANCELATION_INSURANCE = 'INTL_CANCELATION_INSURANCE'
export const AMEND_INSURANCE = 'AMEND_INSURANCE'
export const INTL_FLEXIFLY = 'INTL_FLEXIFLY'
